const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- api-overview ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    schema: { type: Object, required: true },
  }

  init() {
    // Placeholders with angle brackets live in state: in the template they would parse as tags.
    this.state.bearer = 'Authorization: Bearer <key>'
    this.state.classPath = 'POST /api/<group>/<action>'
    this.state.objectPath = 'POST /api/<group>/<ref>/<action>'
    const origin = window.location.origin
    this.state.origin = origin
    this.state.curlJson = `curl -X POST ${origin}/api/sys/health \\\n  -H "Content-Type: application/json" \\\n  -d '{}'`
    this.state.curlSession = `curl -X POST ${origin}/api/auth/me \\\n  -H "Content-Type: application/json" \\\n  -b "mailcog_session=$SESSION" \\\n  -d '{}'`
    this.state.rpc = `curl -X POST ${origin}/api \\\n  -H "Content-Type: application/json" \\\n  -b "mailcog_session=$SESSION" \\\n  -d '{"method": "session/list", "params": {}}'`
    this.state.success = JSON.stringify(
      { success: true, status: 200, message: null, data: { user: { ref: 'usr_K3j9X2m8P1qabc', name: 'Ana Horvat', username: 'ana', avatar: null, email: 'ana@example.com' }, mailbox: null, is_admin: false }, error: null, meta: { action: 'auth/me', request_id: 'rq_4F2k9D7a1B3c', time_ms: 3 } },
      null,
      2,
    )
    this.state.failure = JSON.stringify(
      { success: false, status: 400, message: null, data: null, error: { code: 'bad_ref', message: 'Expected a session ref like ses_K3j9X2m8P1qabc', details: {} }, meta: { action: 'session/{ref}/revoke', request_id: 'rq_9b2c1d0e4f6a', time_ms: 1 } },
      null,
      2,
    )
  }

  beforeRender() {
    this.state.count = this.props.schema.actions.length
    this.state.groups = new Set(this.props.schema.actions.map((a) => a.group)).size
  }

  CSS = `:fez {
display:block;.page{max-width:880px;padding:var(--space-10) var(--space-8) var(--space-12)}h1{font-size:var(--text-2xl);letter-spacing:-0.02em}.lead{margin-top:var(--space-3);color:var(--color-text-muted);font-size:var(--text-lg)}.stats{display:flex;gap:var(--space-2);margin-top:var(--space-4)}section{margin-top:var(--space-10);h2{margin-bottom:var(--space-3);font-size:var(--text-lg)}p,li{color:var(--color-text-muted)}p + p,p + .ui-copy-fez,.ui-copy-fez + p{margin-top:var(--space-3)}ul{margin:var(--space-2) 0 0;padding-left:var(--space-5)}code{padding:1px 5px;border-radius:var(--radius-sm);background:var(--color-code-bg);color:var(--color-code-text)}}.grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:var(--space-4);margin-top:var(--space-3)}pre{margin:0;padding:var(--space-4);border:1px solid var(--color-border);border-radius:var(--radius-md);background:var(--color-code-bg);color:var(--color-text);font-size:var(--text-xs);line-height:1.6;overflow-x:auto}table{width:100%;margin-top:var(--space-3);border-collapse:collapse;font-size:var(--text-sm);th,td{padding:var(--space-2) var(--space-3);border-bottom:1px solid var(--color-border);text-align:left;vertical-align:top}th{color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.04em;text-transform:uppercase}td{color:var(--color-text-muted)}}
}`

  HTML = `<div class="page">
<h1>MailCog API</h1>
<p class="lead">Everything the app does goes through this API. Call any action you are allowed to from scripts, bots or your own client; each action's page says who may.</p>
<div class="stats">
<ui-badge tone="accent" label="{state.count} actions"></ui-badge>
<ui-badge label="{state.groups} groups"></ui-badge>
<ui-badge label="POST only"></ui-badge>
</div>

<section>
<h2>Authentication</h2>
<p>Browser sign-in is AuthCog; the app then runs its own session. The session cookie <code>mailcog_session</code> holds a random token whose sha256 is stored server side. Cookie calls must come from this site's origin.</p>
<p>Scripts and AI assistants send a mailbox key instead, <code>{state.bearer}</code>, created by an operator in the container's Mailboxes settings. A key acts for its mailbox only and reaches the actions marked <code>mail</code>; an unknown key is answered after a second. <code>POST /mcp</code> serves those actions as MCP tools.</p>
<p>Some actions are public, marked on their page.</p>
</section>

<section>
<h2>Requests</h2>
<p>Every action is <code>{state.classPath}</code>, or <code>{state.objectPath}</code> when it works on one object. Params can be JSON or a form body; both fill the same typed params, so these two calls are the same:</p>
<div class="grid">
<ui-copy multiline value={state.curlJson}></ui-copy>
<ui-copy multiline value={state.curlSession}></ui-copy>
</div>
<p>JSON-RPC style works too: post <code>&#123;"method", "params"&#125;</code> to <code>/api</code>.</p>
<ui-copy multiline value={state.rpc}></ui-copy>
<ul>
<li>Unknown params are rejected, so typos never pass silently.</li>
<li>Arrays in forms repeat the key: <code>users=usr_a&amp;users=usr_b</code>. Booleans accept <code>true/false/1/0/on/off</code>.</li>
<li>Objects are addressed by refs such as <code>usr_K3j9X2m8P1qabc</code>; the prefix names the type.</li>
</ul>
</section>

<section>
<h2>Responses</h2>
<p>Every response has the same root keys. <code>status</code> matches the HTTP status: 200 on success, 400 for every handled error, 500 only for bugs; <code>data</code> holds the action result.</p>
<div class="grid">
<pre>{state.success}</pre>
<pre>{state.failure}</pre>
</div>
</section>

<section>
<h2>Errors</h2>
<p>Check <code>error.code</code> and show <code>error.message</code>; <code>error.details</code> maps params to messages for <code>validation_failed</code>.</p>
<table>
<thead>
<tr><th>Code</th><th>When</th></tr>
</thead>
<tbody>
{#each props.schema.errors as error}
<tr><td><code>{error.code}</code></td><td>{error.when}</td></tr>
{/each}
</tbody>
</table>
</section>
</div>`
};
}

Fez('api-overview', __fez_component_0);

export default __fez_component_0;
